/**
 * 📊 Códigos oficiales de reportes del sistema
 * Fuente única de verdad (alineado con BD)
 */
export const REPORT_CODES = {
  // =========================
  // 📦 INVENTARIO
  // =========================
  INVENTARIO_INICIAL: 'INVENTARIO_INICIAL',
  EXISTENCIAS_INVENTARIO: 'EXISTENCIAS_INVENTARIO',
  MOVIMIENTOS_INVENTARIO: 'MOVIMIENTOS_INVENTARIO',
  AJUSTES_INVENTARIO: 'AJUSTES_INVENTARIO',
  KARDEX_INVENTARIOS: 'KARDEX_INVENTARIOS',

  // =========================
  // 🛒 PRODUCTOS
  // =========================
  PRODUCTOS: 'PRODUCTOS',
  PRODUCTOS_MAS_VENDIDOS: 'PRODUCTOS_MAS_VENDIDOS',
  UTILIDAD_BRUTA_PRODUCTOS: 'UTILIDAD_BRUTA_PRODUCTOS',
  PRECIOS_DE_VENTAS: 'PRECIOS_DE_VENTAS',
  STOCK_NEGATIVO: 'STOCK_NEGATIVO',

  // =========================
  // 👥 CLIENTES
  // =========================
  CLIENTES: 'CLIENTES',
  CLIENTES_FRECUENTES: 'CLIENTES_FRECUENTES',

  // =========================
  // 🧑‍💼 PROVEEDORES
  // =========================
  PROVEEDORES: 'PROVEEDORES',

  // =========================
  // 💰 VENTAS
  // =========================
  VENTAS_CLIENTES_TOTALES: 'VENTAS_CLIENTES_TOTALES',
  VENTAS_CLIENTES_PRODUCTOS: 'VENTAS_CLIENTES_PRODUCTOS',
  VENTAS_POR_SUCURSALES: 'VENTAS_POR_SUCURSALES',
  VENTAS_POR_FORMA_PAGO: 'VENTAS_POR_FORMA_PAGO',
  VENTAS_DIARIAS_GRUPO: 'VENTAS_DIARIAS_GRUPO',

  // =========================
  // 🧾 REPORTES FISCALES / HACIENDA
  // =========================
  ANEXO_CONSUMIDOR_FINAL: 'ANEXO_CONSUMIDOR_FINAL',

  // =========================
  // 🧾 COMPRAS
  // =========================
  COMPRAS_PROVEEDOR_RESUMEN: 'COMPRAS_PROVEEDOR_RESUMEN',
  COMPRAS_PROVEEDOR_PRODUCTOS: 'COMPRAS_PROVEEDOR_PRODUCTOS',
  COMPRAS_SUJETO_EXCLUIDO: 'COMPRAS_SUJETO_EXCLUIDO',
  COMPRAS_POR_FORMA_PAGO: 'COMPRAS_POR_FORMA_PAGO',

  // =========================
  // 📈 RENTABILIDAD / COSTOS
  // =========================
  COSTO_DE_VENTAS: 'COSTO_DE_VENTAS',

  // =========================
  // 🏦 FINANZAS — CxC
  // =========================
  ESTADO_CUENTA_CLIENTE: 'ESTADO_CUENTA_CLIENTE',
  REPORTE_AGING_CXC: 'REPORTE_AGING_CXC',
  CUENTAS_POR_COBRAR_VENCIDAS: 'CUENTAS_POR_COBRAR_VENCIDAS',

  // =========================
  // 🏦 FINANZAS — CxP
  // =========================
  ESTADO_CUENTA_PROVEEDOR: 'ESTADO_CUENTA_PROVEEDOR',
  REPORTE_AGING_CXP: 'REPORTE_AGING_CXP',
  CUENTAS_POR_PAGAR_VENCIDAS: 'CUENTAS_POR_PAGAR_VENCIDAS',

  // =========================
  // 🧾 POS / CAJA
  // =========================
  REPORTE_X: 'REPORTE_X',
  REPORTE_Z: 'REPORTE_Z',
} as const;

/**
 * 🔐 Tipo seguro para códigos de reporte
 */
export type ReportCode =
  typeof REPORT_CODES[keyof typeof REPORT_CODES];